module.exports = __webpack_public_path__ + "static/media/user-default-icon.e64ccd76.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/user-default-icon.png
// module id = 711
// module chunks = 0